// src/components/CredentialManagement/CredentialList.js
import React from "react";
import PropTypes from "prop-types";
import CredentialCard from "./CredentialCard";
import logger from "../../utils/logger";

// Create composite key from deviceId and credentialId
const makePendingKey = (deviceId, credentialId) =>
  `${deviceId}:${credentialId}`;

/**
 * CredentialList - Grid layout wrapper for credential cards
 *
 * Manages the credential grid display and handles pending deletion tracking.
 */
const CredentialList = ({
  credentials,
  selectedDeviceId,
  patronsMap,
  pendingDeletionCredentials,
  offlineDeviceCredentials,
  devicesWithPendingDeletions,
  onDeleteCredential,
}) => {
  if (credentials.length === 0) {
    return <p>No credentials found for this device.</p>;
  }

  return (
    <main className="credential-grid">
      {credentials.map((cred) => {
        const patron = cred.patronId ? patronsMap[cred.patronId] : null;
        const pendingKey = makePendingKey(selectedDeviceId, cred.id);
        const isPendingDeletion = pendingDeletionCredentials.has(pendingKey);
        const isOffline = offlineDeviceCredentials.has(pendingKey);
        const deviceHasPendingDeletions =
          devicesWithPendingDeletions.has(selectedDeviceId);

        // Log first credential for debugging
        if (cred === credentials[0]) {
          logger.log(
            `[RENDER] 🎨 Device ${selectedDeviceId} first credential:`
          );
          logger.log(`[RENDER] - credential ID: ${cred.id}`);
          logger.log(`[RENDER] - pendingKey: ${pendingKey}`);
          logger.log(`[RENDER] - isPendingDeletion: ${isPendingDeletion}`);
          logger.log(`[RENDER] - isOffline: ${isOffline}`);
          logger.log(
            `[RENDER] - deviceHasPendingDeletions: ${deviceHasPendingDeletions}`
          );
          logger.log(
            `[RENDER] - offlineDeviceCredentials:`,
            Array.from(offlineDeviceCredentials)
          );
          logger.log(
            `[RENDER] - devicesWithPendingDeletions:`,
            Array.from(devicesWithPendingDeletions)
          );
          logger.log(
            `[RENDER] - pendingDeletionCredentials:`,
            Array.from(pendingDeletionCredentials)
          );
          logger.log(`[RENDER] - Timestamp: ${new Date().toISOString()}`);
        }

        return (
          <CredentialCard
            key={cred.id}
            credential={cred}
            patron={patron}
            isPendingDeletion={isPendingDeletion}
            isOffline={isOffline}
            deviceHasPendingDeletions={deviceHasPendingDeletions}
            onDelete={onDeleteCredential}
          />
        );
      })}
    </main>
  );
};

CredentialList.propTypes = {
  credentials: PropTypes.array.isRequired,
  selectedDeviceId: PropTypes.string.isRequired,
  patronsMap: PropTypes.object.isRequired,
  pendingDeletionCredentials: PropTypes.instanceOf(Set).isRequired,
  offlineDeviceCredentials: PropTypes.instanceOf(Set).isRequired,
  devicesWithPendingDeletions: PropTypes.instanceOf(Set).isRequired,
  onDeleteCredential: PropTypes.func.isRequired,
};

export default CredentialList;
